import { mapState } from 'vuex';
import Form from './Form';

export default {
	mixins: [Form],
	props: {
		step: {
			type: Number,
			default: 1
		},
	},
	data() {
		return {
			formData: {},
			totalSteps: 1, //Total number of form steps
			routeBase: '/',
		}
	},
	computed: {
		...mapState({
			currentStep: state => state.form.currentStep,
			completedStep: state => state.form.completedStep,
		}),
	},
	methods: {},
	watch: {
		currentStep(newValue, oldValue) {
			if(oldValue !== newValue) {
				// this.$router.push(`${this.routeBase}/${newValue}`);
			}
		},
	},
	beforeRouteUpdate(to, from, next) {
		let step = parseInt(to.params.step);

		if((step <= this.totalSteps) && (step <= this.completedStep + 1)) {
			this.$store.commit('form/setCurrentStep', step);
			next();
		} else {
			next(false);
		}
	},
	created() {
		this.$store.commit('form/setTotalSteps', this.totalSteps);
		this.$store.commit('form/setCurrentStep', this.step);
	}
}
